<template>
  <p class="text-body-1">
    Redirecting you to the quiz...
  </p>
</template>

<script>
import firebase from 'firebase';
export default {
  methods: {
    confirmPayment: function() {
      // Try to grab the authenticated user token.
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          // If the user is autnenticated, retrieve their session token.
          firebase.auth().currentUser.getIdToken( true).then(idToken => {
            const t = { token: idToken };
            this.$http.post("https://us-central1-waldock-my-life-pie.cloudfunctions.net/api/confirm-payment", t).then(response => {
              console.log(response);
              this.$router.push("/initial");
            });
          }).catch(function(error) {
            alert(error);
          });
        } 
        else {
          // User is signed out
        }
      });
    }
  },
  mounted() {
    this.confirmPayment();
  }
}
</script>